import './frontpage.less';

angular.module('tromanWeb').controller('FrontController', ['tromanServer', 'systemInfo', function FrontController(tromanServer, systemInfo) {
    this.systemInfo = systemInfo;
    tromanServer.Notifications.getFrontPagenotifications().then(result => {
        this.notifications = result;
    });
}]);